import axios from "axios";
import { getAllUserList } from "../../config/apiConfig";
import {
    FETCH_USER_BEGIN,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILURE
} from '../constants/User';
import { sbaAxios } from "../utils/sbaAxios";

export const getAllUsers = () => {
    return (dispatch) => {
        dispatch(fetchUserBegin());
        sbaAxios({url:`${getAllUserList}`,method:'get'}).then((repos) => {
            const users = repos;
            dispatch(fetchUserSuccess(users));
            return users;
        })
        .catch((error) => dispatch(fetchUserFailure(error)));
    };
}

export const fetchUserBegin = () => ({
    type: FETCH_USER_BEGIN,
});

export const fetchUserSuccess = (Users) => ({
    type: FETCH_USER_SUCCESS,
    payload: { Users },
});


export const fetchUserFailure = (errorMessage) => ({
    type: FETCH_USER_FAILURE,
    payload: { errorMessage }
});
